import type { CarriedUp, PersonInvolvementKind } from "../types/involvement.js";
import type { OrganisationMembershipGate } from "../types/organisation.js";
import { administeringInvolvementKind } from "./administeringInvolvementKind.js";
import { involvementKindsCarryingViewUp } from "./involvementKindsCarryingViewUp.js";

/**
 * For each thing an organisation membership can carry up, the kinds of
 * involvement a member must hold to carry it, and the setting, if any, the
 * receiving organisation must have on to receive it. Explain the rules from
 * this table rather than restating them.
 */
export const carryUpConditionsByCarriedUp: Record<
  CarriedUp,
  {
    involvements: readonly PersonInvolvementKind[];
    gatedBy: OrganisationMembershipGate | null;
  }
> = {
  view: { involvements: involvementKindsCarryingViewUp, gatedBy: null },
  admin: { involvements: [administeringInvolvementKind], gatedBy: null },
  "approved-assessments": {
    involvements: involvementKindsCarryingViewUp,
    gatedBy: "readsApprovedAssessmentsThroughMembers",
  },
};
